import { edit , saveNode } from "@api/admin.js";
export default {
  data() {
    return {
      paasFormData:{
        paasRepeatSubmitFlag:'',//重复提交标识
        submitModifyData:'', //保存时传至后台的修改数据
      },
      defaultLabelWidth:100, //默认表单域标签的宽度,所有的 FormItem 都会继承 Form 组件的 label-width 的值
      wrapperWidth:'80%', //自定义form-wrap的宽度
      redirectName:'',  //若非keepAlive页面，保存和返回则跳转这个页面
      showFlag:false, //是否显示下拉树,默认不显示
      isAddActive:true,  //判断是添加还是修改，默认是添加
      treeData:[], //参照树节点
      nextAddName:'',//保存并添加操作
      keepAliveName:'',
      defaultEnumKey:'', //有默认值的枚举字段
      currentIdFiledName: '', //当前id字段
      oldValue:{},//监控的input修改前的值。
      modifyData:[],//修改记录表单数据汇总
      modify:{},//修改的某一条数据
      sysModifyTraceName:'',//表单实体名称
      fieldName:'',//表单中文名
      reasonModify:'', //修改原因
      isModify:false, //是否显示修改记录
      modifyColumns:[
        {
          title: '属性',
          key: 'fieldlabel'
        },
        {
          title: '修改前值',
          key: 'oldValue'
        },
        {
          title: '修改后值',
          key: 'newValue'
        },
        {
          title: '修改原因',
          key: 'reasonModify'
        },
        {
          title: '修改人',
          key: 'userName'
        },
        {
          title: '修改时间',
          key: 'timeModify'
        },
      ],
      modifyRecords:[],
      modifyTraceFiledName:'',//需要跟踪的字段
    }
  },
  created() {
    this.create();
  },
  methods:{
    create(){
      //通过路由获取的参数
      let queryParam = this.$route.query;
      let param = '';
      for(let key in queryParam) {
        if(key === "queryParam") {
          continue;
        }
        if(param) {
          param += "&";
        }
        param += key+"="+this.$route.query[key];
      }
      if(queryParam[this.currentIdFiledName] && queryParam[this.currentIdFiledName] !==undefined && queryParam[this.currentIdFiledName] !=='undefined'){
        this.isModify = true;
      }
      /**
       * 加载edit页面数据
       */
      edit(this.serviceUrl,param).then(res => {
        if(res.code === 200) {
          let data = res.data;
          let entity = data.entity;
          for(let key in this.paasFormData) {
            if((key in entity)) {
              if(entity[key] !== null && entity[key] !== 'null' && typeof entity[key] !== "undefined") {
                if((key in entity)) {
                  if(entity[key] !== null && entity[key] !== 'null' && typeof entity[key] !== "undefined") {
                    if(entity[this.currentIdFiledName]){
                      this.paasFormData[key] = entity[key];
                      if(this.modifyTraceFiledName.indexOf(key) !== -1){
                        this.oldValue[key] = entity[key]
                      }
                    }else{
                      if(this.defaultEnumKey.indexOf(key) ===-1){
                        this.paasFormData[key] = entity[key];
                      }
                    }
                  }
                }
              }
            }
          }
          if(entity[this.currentIdFiledName]){
            this.isAddActive = false;
          }
          this.paasFormData.paasRepeatSubmitFlag = data.paasRepeatSubmitFlag;
          this.createdCallback(data);
        }
      }).catch(function(error){
        console.log("edit的数据："+error);
        this.$Message.error('数据加载失败，请重试！');
      });

    },
    createdCallback(data) {

    },
    /**
     *  修改时监控数据变化
     */
    addModifyRecord(attribute,isRecordReason,label){
      let id = this.$route.query[this.currentIdFiledName];
      //有id 时监控数据变化
      if(id && id !== undefined && id !=="undefined" && this.oldValue[attribute] !== this.paasFormData[attribute]){
        // 先判断修改的属性是否为首次修改，若不是：直接修改已存数据的newValue值，若是：新增一条数据
        if(this.modifyData.length>0){
          let flag = true;
          for(let i=0;i<this.modifyData.length;i++){
            //先判断修改的属性值与原来的属性值是否相同，若相同，应清除this.modifyData中的属性。
            if(this.modifyData[i].fieldlabel === attribute ){
              if(this.oldValue[attribute] === this.paasFormData[attribute]){
                this.modifyData.splice(i,1);
                flag = false;
                break;
              }else{
                // 若不同则直接修改this.modifyData中的newValue值：
                this.modifyData[i].newValue = this.paasFormData[attribute];
                flag = false;
                break;
              }
            }
          }
          if(flag){
            this.setModifyData(attribute,id,isRecordReason,label);
          }
        }else{
          this.setModifyData(attribute,id,isRecordReason,label);
        }
      }
    },

    /**
     *  组装修改记录数据
     */
    setModifyData(attribute,id,isRecordReason,label){
      this.modify = {
        bussinessId:id,
        sysModifyTraceName:this.sysModifyTraceName,
        fieldName:this.fieldName,
        fieldlabel:label,
        oldValue:this.oldValue[attribute],
        newValue:this.paasFormData[attribute],
        reasonModify:'',
      }
      if(isRecordReason){
        this.showModifyReasonModel();
      }
      this.modifyData.push(this.modify);
      console.log(this.modifyData)
    },

    /**
     * 弹出填写修改原因的模态框
     */
    showModifyReasonModel(){
      this.$Modal.confirm(
        {
          title:'修改原因',
          render:(h)=>{
            return h('div',[
                h('div',{
                  style:{
                    margin:'10px',
                    display: 'flex',
                    alignItems:'center'
                  },
                },[
                  h('label','备选原因：'),
                  h('Select',{
                    props: {
                      placeholder: '可选择备选原因',
                    },
                    style:{width:'200px'},
                    on:{
                      'on-change':(val)=>{
                        this.modify.reasonModify = val;
                      }
                    }
                  },[
                    h('Option',{
                      props:{
                        value:'填写错误'
                      }
                    }),
                    h('Option',{
                      props:{
                        value:'业务变更'
                      }
                    }),
                  ])
                ]),
                h('div', {
                  style:{
                    margin:'10px',
                    display: 'flex',
                    alignItems:'center'
                  },
                },[
                  h('label','原因：'),
                  h('Input',{
                    props:{
                      type:'textarea',
                      autosize:true,
                      placeholder:'填写修改原因',
                      value:this.modify.reasonModify,
                    },
                    style:{width:'300px'},
                    on:{
                      'input':(val)=>{
                        this.modify.reasonModify = val;
                      }
                    }
                  }),
                ]),
              ]
            )
          },
        }
      );
    },
    /**
     * 修改记录模态框
     */
    showModifyRecords(){
      const title = '<p style="font-size: 14px; font-weight: 500">修改痕迹</p>'
      this.$Modal.info(
        {
          title:title,
          render:(h)=>{
            return h('Table',{
              props:{
                columns:this.modifyColumns,
                data: this.modifyRecords,
              },
            })
          },
          width:'1000px',
        }
      )
    },

    /**
     * 获取修改记录数据
     */
    getModifyRecords(){
      let id = this.$route.query[this.currentIdFiledName]
      if(id && id !== undefined && id !=='undefined'){
        this.axios.get(this.$store.state.sysApi+'/sys/modify/trace/getTableByBussinessId?bussinessId='+id).then(
          res=>{
            if(res.code === 200){
              this.modifyRecords = res.data
              this.showModifyRecords();
            }
          }
        ).catch(
          error=>{
            this.$Message.error('修改记录获取失败！')
          }
        );
      }
    },
    /**
     * 显示节点下拉树
     */
    changeShowFlag(){
      this.showFlag = true;
    },
    updateTreeParentNode(node){
      this.paasFormData.parentId = node.id;
      this.paasFormData.parentName = node.title;
      this.showFlag = false;
    },
    /**
     * 保存逻辑
     * @param name
     * @param url
     */
    paasFormSubmit(name,url,type){
      if(!url) {
        url = this.$store.state.sysApi+this.serviceUrl+"/saveNode";
      }
      this.paasFormSubmitBefore();
      this.$refs[name].validate((valid) => {
        if (valid){
          if(this.modifyData.length>0){
            this.paasFormData.submitModifyData = JSON.stringify(this.modifyData);
          }

          console.log(this.paasFormData);
          saveNode(url, this.paasFormData).then(res => {
            if(res.code === 200) {
              this.$Message.info('数据保存成功！');
              let returnUrl = this.serviceUrl+"/list";
              if(this.returnUrl) {
                returnUrl = this.returnUrl;
              }
              //修改的参数||新增的参数(需要主键id值，所以使用后台返回的值)
              /*returnUrl += "?"+this.currentIdFiledName+"="+res.body.entity[this.currentIdFiledName];
              this.$router.push({'path': this.setUrlFuncId(returnUrl)});*/
              /**
               * 修改
               */
              let flag = "";
              if(this.paasFormData[this.currentIdFiledName]) {
                flag = "edit"
              }
              /**
               * 添加
               */
              else{
                flag = "add";
              }
              this.$bus.emit("update-tree",flag,res);

              this.paasFormSubmitAfter(res);
              this.paasFormRouterPush(res,type);
            }
          }).catch(function (error) {
            this.$Message.error('数据保存失败，请重试！');
          });
        }
      })
    },

    /**
     * 保存前逻辑
     */
    paasFormSubmitBefore(){

    },
    /**
     * 保存后、路由跳转前逻辑
     * @param res
     */
    paasFormSubmitAfter(res){

    },
    /**
     * 路由跳转逻辑
     * @param res
     */
    paasFormRouterPush(res,type){
      let redirectPath = this.redirectName;
      let fieldName = this.currentIdFiledName;
      if(type==='add'){
        redirectPath = this.nextAddName;
        this.$emit('getKeyChange');
        fieldName = 'parentId';
      }
      if(this.keepAliveName && typeof(this.keepAliveName) !== "undefined"){
        redirectPath = this.keepAliveName;
      }
      this.$router.push({
        name:redirectPath,
        params: {
          updateData: [res.data.entity]
        },
        query: {
          paasCurrentFunctionId: this.$route.query[this.$store.state.funcIdName],
          [fieldName]:this.paasFormData.parentId,
        },
      })
    },
    /**
     * 点击关闭逻辑，一般默认跳转list路由页面
     * @param event
     * @param url
     */
    paasPageBack(event, url){
      let parentId = this.$route.query.parentId;

      if(!url) {
        url = this.serviceUrl+"/list";
      }
      if(parentId && typeof (parentId) !== "undefined"){
        url += "?"+this.currentIdFiledName+"="+parentId;
      }
      this.$router.push({'path': this.setUrlFuncId(url)});
    },
    /**
     * url添加功能ID参数,封装这个方法是以防功能配置也有传参数
     * @param url
     * @returns {*}
     */
    setUrlFuncId(url) {
      if(url.indexOf("?") !== -1) {
        url += '&';
      } else {
        url += '?';
      }
      //组装paasCurrentFunctionId=***
      url += this.$store.state.funcIdName+'='+this.$route.query[this.$store.state.funcIdName];
      return url;
    }
  },

  /**
   * 如果返回的页面存在keep-alive，需要加上这个，还需要配置一下keepAliveName,这个参数配置与list的配对的
   * 导航离开该组件的对应路由时调用
   * 可以访问组件实例 `this`
   * @param to
   * @param from
   * @param next
   */
  beforeRouteLeave(to, from, next) {
    if(this.keepAliveName && typeof(this.keepAliveName) !== 'undefined'){
      if(this.keepAliveName.indexOf(to.name) !== -1){
        to.meta.keepAlive = true;
        next();
      }
      else{
        to.meta.keepAlive = false;
        next();
      }
    }else{
      next();
    }
  }
}
